// Avatars are stored at most this wide/tall. Anything larger is scaled down
// before it leaves the browser; anything smaller is left alone.
const MAX_AVATAR_DIMENSION = 600;

/**
 * Turn a picked image file into the JPEG data URL the avatar endpoints take.
 *
 * Lives here rather than inside a component because two surfaces pick avatars —
 * the mobile uploader and the desktop settings dialog — and a second copy of the
 * canvas maths is a second answer to "how big is an avatar".
 */
export function compressAvatarImage(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = document.createElement("img");

    image.addEventListener("load", () => {
      URL.revokeObjectURL(objectUrl);
      const canvas = document.createElement("canvas");
      // Never upscale: a small photo stays its own size.
      const scale = Math.min(
        1,
        MAX_AVATAR_DIMENSION / Math.max(image.width, image.height)
      );
      canvas.width = Math.round(image.width * scale);
      canvas.height = Math.round(image.height * scale);
      const context = canvas.getContext("2d");
      if (context === null) {
        reject(new Error("should not happen: no 2d canvas context"));
        return;
      }
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/jpeg"));
    });

    image.addEventListener("error", () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("The picture could not be read"));
    });

    image.src = objectUrl;
  });
}
